export const convertToAbsoluteHumidity = ({ temperature, humidity }) => {
  return (
    (6.112 *
      Math.pow(Math.E, (17.67 * temperature) / (temperature + 243.5)) *
      humidity *
      2.1674) /
    (273.15 + temperature)
  )
}
